import axios from 'axios';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router';
import Swal from 'sweetalert2';
import DataTable from '../components/DataTable';

const ListaJefes = () => {
  const [jefes, setJefes] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // Eliminar jefe
  const deleteJefe = async (id) => {
    try {
      Swal.fire({
        title: '¿Está seguro?',
        text: '¡No podrá revertir este proceso!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      }).then(async (result) => {
        if (result.isConfirmed) {
          const { data } = await axios.delete(`/api/jefe/${id}`);
          await getData(); // refrescar
          Swal.fire({
            icon: 'success',
            title: data.message || 'Jefe eliminado',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      });
    } catch (error) {
      console.error('Error al eliminar el jefe:', error.message);
      Swal.fire('Error', 'No se pudo eliminar el jefe.', 'error');
    }
  };

  // Obtener datos
  const getData = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await axios.get('/api/jefe/listall/');

      const jefesConFunciones = (data?.jefes || []).map((jefe) => ({
        ...jefe,
        funciones: (
          <div className="d-flex align-items-center justify-content-end gap-2 flex-nowrap">
            {/* Editar asociaciones */}
            <button
              className="btn btn-warning btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => navigate(`/enteconformador/jefes/edit/${jefe._id}`)}
              title="Editar Asociaciones"
              type="button"
            >
              <i className="fa-solid fa-pen-to-square"></i>
            </button>

            {/* Eliminar */}
            <button
              className="btn btn-danger btn-sm d-inline-flex align-items-center justify-content-center"
              style={{ width: 34, height: 34 }}
              onClick={() => deleteJefe(jefe._id)}
              title="Eliminar"
              type="button"
            >
              <i className="fa-solid fa-trash"></i>
            </button>
          </div>
        ),
      }));

      setJefes(jefesConFunciones);
    } catch (error) {
      console.error('Error al cargar los jefes:', error.message);
      setJefes([]);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [navigate]);

  useEffect(() => {
    getData();
  }, [getData]);

  const columns = useMemo(
    () => [
      { Header: 'Documento', accessor: 'documentoJefe' },
      { Header: 'Nombre', accessor: 'nombre1Jefe' },
      { Header: 'Apellido', accessor: 'apellido1Jefe' },
      { Header: 'Teléfono', accessor: 'telefono1Jefe' },
      {
        Header: 'Email',
        accessor: 'emailJefe',
        width: 280,
        hideHeaderOnMobile: true,
      },
      { accessor: 'funciones' },
    ],
    []
  );

  return (
    <div>
      <div className="container-fluid px-2 px-md-4">
        <div className="bg-white border rounded-4 shadow-sm overflow-hidden">
          {/* Header */}
          <div className="px-3 px-md-4 py-3 border-bottom bg-white">
            <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
              <div>
                <h5 className="mt-2 mb-1 fw-semibold">Jefes Inmediatos / Rectores</h5>
                <small className="text-secondary">
                  Gestión de jefes y asociaciones institucionales.
                </small>
              </div>

              <div className="d-flex gap-2 flex-wrap">
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => getData()}
                  title="Actualizar"
                  disabled={loading}
                >
                  <i className={`fa-solid ${loading ? 'fa-spinner fa-spin' : 'fa-rotate'} me-2`}></i>
                  Actualizar
                </button>

                {/* ✅ BOTÓN NUEVO */}
                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate('/enteconformador/jefes/nuevo')}
                  title="Crear Jefe"
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Nuevo
                </button>
              </div>
            </div>
          </div>

          {/* Body */}
          <div>
            {loading ? (
              <div className="text-center text-secondary py-5">
                <div className="spinner-border" role="status" aria-hidden="true"></div>
                <div className="mt-3">Cargando jefes…</div>
              </div>
            ) : Array.isArray(jefes) && jefes.length > 0 ? (
              <div className="overflow-hidden">
                <DataTable columns={columns} data={jefes} />
              </div>
            ) : (
              <div className="text-center text-secondary py-5">
                <div className="display-6 mb-2">🐾</div>
                <div className="fw-semibold">No hay jefes registrados</div>
                <div className="small mb-3">Crea el primer registro para iniciar la gestión.</div>

                {/* ✅ CTA en vacío (opcional, pero muy mrgestor) */}
                <button
                  className="btn btn-dark"
                  type="button"
                  onClick={() => navigate('/enteconformador/jefes/nuevo')}
                >
                  <i className="fa-solid fa-plus me-2"></i>
                  Registrar jefe
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaJefes;
